
import Vue from 'vue'
import Router from 'vue-router'

import Index from '../page/Index'
const Invest = () => import('../page/Invest')
const Help = () => import('../page/Help')
const About = () => import('../page/About')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/invest',
      name: 'invest',
      component: Invest
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/about',
      name: 'about',
      component: About
    }
  ]
})



// WEBPACK FOOTER //
// ./src/apps/zcx/router/index.js